<template>
    <div v-show="!market.closed && !market.isDisabled">
        <row v-if="market.odd && Object.values(market.odd).length <= 3" :odd="market" :match="match" :selectedOdds="selectedOdds" />
        <block v-if="market.odd && Object.values(market.odd).length > 3" :odd="market" :match="match" :selectedOdds="selectedOdds" />
        <bundle v-if="market.bundle" :odd="market" :match="match" :selectedOdds="selectedOdds" />
        <!-- <score v-if="market.template === 'Score'" :odd="market" :match="match" :selectedOdds="selectedOdds" /> !-->
    </div>
</template>

<script>

    import row from './template/row'
    import score from './template/score'
    import block from './template/block'
    import bundle from './template/bundle'
    export default {
        name: "market",
        components: {row, score, block, bundle},
        props: ['market', 'match'],
        data () {
            return {
                selectedOdds: [],
                isDisabled: false,
            }
        },
        watch: {
            'market' (m) {
                this.isDisabled = m.disabled
            },
        },
        mounted (){
            this.$bus.$on('addBet', ($event) => {
                this.selectedOdds = $event;
            })
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/sportsbook/market/market.vue